<script lang="ts">
	/**
	 * A small component that allows to dynamicly render different HTML elements.
	 * Can be used as follows:
	 * <WYSIWYG text={data.text} />
	 */

	export let text: string; // HTML content to be rendered inside the dynamic element.
	export let tag: string = 'div'; // HTML tag for the dynamic element (default: 'div').
</script>

<div class="container">
	<svelte:element this={tag}>{@html text}</svelte:element>
</div>

<style lang="scss">
	.container {
		:global(strong) {
			font-weight: bold;
		}
		:global(em) {
			font-style: italic;
		}
		:global(ul) {
			list-style: disc;
			padding: var(--content-gap) 0 var(--content-gap) var(--content-gap-lg);
		}
		:global(ol) {
			list-style: normal;
			padding: var(--content-gap) 0 var(--content-gap) var(--content-gap-lg);
		}
		:global(h1) {
			@include font(h1);
		}
		:global(h2) {
			@include font(h2);
		}
		:global(h3) {
			@include font(h3);
		}
		:global(h4) {
			@include font(h4);
		}
	}
</style>
